export default __webpack_public_path__ + "static/media/pool.07806048.webp";